import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
  state.isAuthenticated = false;
};

const productSlice = createSlice({
  name: "Product",
  initialState: {
    isLoading: false,

    // farmer: {},
    productsList: [],
    //regionList: [],
  },
  reducers: {

     // Create schedualer
     createProductRequest: (state) => setLoading(state, true),
     createProductSuccess: (state) => setLoading(state, false),
     createProductFailure: (state) => setLoading(state, false),

     // Delete delete actions
         deleteProductRequest: (state) => setLoading(state, true),
         deleteProductSuccess: (state) => setLoading(state, false),
         deleteProductFailure: (state) => setFailure(state),
   

  },
});

export const {
 
  createProductRequest,
  createProductSuccess,
  createProductFailure,
  deleteProductRequest,
  deleteProductSuccess,
  deleteProductFailure,
} = productSlice.actions;

export const productReducerSlice = productSlice.reducer;
